import React, { useState } from "react"
import useUpdateEffect from "./useUpdateEffect"

/**
 * Gets an external data and makes it internal.
 */
export default function useScopedState<T>(external: T): [T, React.Dispatch<React.SetStateAction<T>>] {
    const [data, setData] = useState(external)
    useUpdateEffect(() => setData(external), [external])
    return [data, setData]
}